import React, { useState, useEffect } from 'react'
import styles from './styles.module.scss'
import Pill from 'srcReact/components/common2/Pill'
import Button from 'srcReact/components/common2/Button'
import { useDispatch, useSelector } from 'react-redux'
import { profileActions } from 'srcReact/MyProfile/action'
import { useTranslation } from 'react-i18next'
import Spinner from 'srcReact/components/common2/Spinner'

function AddInterestsToProfile({ interests, closeModal }) {
  const { t } = useTranslation()
  const [interestItems, setInterestItems] = useState(interests)
  const [selectedCount, setSelectedCount] = useState(0)
  const dispatch = useDispatch()

  const {
    myProfile: {
      userInterests: { loading, updated, error }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (!loading && updated) {
      closeModal()
      dispatch(profileActions.clearInterestUpdate())
    }
  }, [updated, error, loading])

  const toggleInterest = (interest) => {
    const updatedInterests = interestItems.map((i) => {
      if (i.id == interest.id) {
        i.selected = !i.selected
      }
      return i
    })
    setSelectedCount(updatedInterests.filter((i) => i.selected).length)
    setInterestItems(updatedInterests)
  }

  const addInterestsToProfile = () => {
    let interestIds = interests.map((i) => i.id).join(',')
    if (selectedCount > 0) {
      interestIds = interestItems
        .filter((i) => i.selected)
        .map((i) => i.id)
        .join(',')
    }
    dispatch(profileActions.addInterest(interestIds))
  }

  return (
    <div className={styles.interestWrapper}>
      <div className={styles.interests}>
        {interestItems?.map((interest) => (
          <Pill
            shared={interest.selected}
            dataId={interest.id}
            text={interest.name}
            onClick={() => toggleInterest(interest)}
          />
        ))}
      </div>
      <div className={styles.buttons}>
        <Button style='secondary' text={t('global.no')} handleClick={closeModal} />
        <Button
          text={
            selectedCount > 0 && selectedCount !== interests.length
              ? t('groupHome.addInterestToProfile.buttonAdd', { count: selectedCount })
              : t('groupHome.addInterestToProfile.buttonAddAll', { count: interests.length })
          }
          handleClick={addInterestsToProfile}
        />
      </div>
      {loading && <Spinner />}
    </div>
  )
}

export default AddInterestsToProfile
